// extracted by mini-css-extract-plugin
export default {"container":"EJ-z","dimension":"FJ-z","dimensionLabels":"GJ-z"};